module.exports = __webpack_public_path__ + "img/image_6.187652c1.png";